import { NavItem, Service, Stat } from '@/lib/index';
import { Building2, FileText, TrendingUp, Users, Shield, Lightbulb } from 'lucide-react';

export const navItems: NavItem[] = [
  { label: 'Inicio', href: '#hero' },
  { label: 'Nosotros', href: '#nosotros' },
  { label: 'Servicios', href: '#servicios' },
  { label: 'Contacto', href: '#contacto' }
];

export const services: Service[] = [
  {
    id: 'cobranza',
    title: 'Gestión de Cobranza',
    description: 'Soluciones integrales para la gestión eficiente de procesos de cobranza en entidades públicas, optimizando la recuperación de cartera y mejorando los indicadores financieros.',
    icon: 'FileText'
  },
  {
    id: 'multas',
    title: 'Multas e Infracciones de Tránsito',
    description: 'Plataforma tecnológica especializada para la administración y seguimiento de multas e infracciones de tránsito, garantizando transparencia y eficiencia en los procesos.',
    icon: 'Shield'
  },
  {
    id: 'transformacion',
    title: 'Transformación Digital',
    description: 'Implementación de tecnologías de vanguardia para modernizar procesos administrativos del sector público, mejorando la eficiencia operativa y la atención ciudadana.',
    icon: 'TrendingUp'
  },
  {
    id: 'apoyo',
    title: 'Apoyo Administrativo',
    description: 'Servicios especializados de apoyo en procesos administrativos, optimizando la gestión documental, flujos de trabajo y procedimientos internos de las entidades.',
    icon: 'Building2'
  },
  {
    id: 'consultoria',
    title: 'Consultoría Tecnológica',
    description: 'Asesoría experta en la selección e implementación de soluciones tecnológicas adaptadas a las necesidades específicas del sector público colombiano.',
    icon: 'Users'
  },
  {
    id: 'innovacion',
    title: 'Innovación y Desarrollo',
    description: 'Desarrollo de soluciones tecnológicas personalizadas que impulsan la innovación en la gestión pública, utilizando las últimas tendencias en tecnología.',
    icon: 'Lightbulb'
  }
];

export const stats: Stat[] = [
  {
    id: 'experience',
    value: '5',
    label: 'Años de Experiencia',
    suffix: '+'
  },
  {
    id: 'clients',
    value: '50',
    label: 'Entidades Atendidas',
    suffix: '+'
  },
  {
    id: 'projects',
    value: '100',
    label: 'Proyectos Exitosos',
    suffix: '+'
  },
  {
    id: 'satisfaction',
    value: '98',
    label: 'Satisfacción del Cliente',
    suffix: '%'
  }
];

export const values = [
  {
    id: 'innovation',
    title: 'Innovación Constante',
    description: 'Nos mantenemos a la vanguardia tecnológica, implementando soluciones innovadoras que transforman la gestión pública.',
    icon: 'Lightbulb'
  },
  {
    id: 'transparency',
    title: 'Transparencia',
    description: 'Operamos con total transparencia en todos nuestros procesos, garantizando confianza y credibilidad con nuestros clientes.',
    icon: 'Shield'
  },
  {
    id: 'efficiency',
    title: 'Eficiencia',
    description: 'Optimizamos recursos y procesos para entregar resultados medibles que mejoran el desempeño de las entidades públicas.',
    icon: 'TrendingUp'
  }
];
